import classNames from 'classnames';
import { Icon } from '@components/icon';
import './TileSelect.scss';

export type TileSelectProps = {
  checked?: boolean;
};

/**
 * Tile Select Component
 * @param checked - If true, the component is checked.
 * @constructor
 */

export const TileSelect: React.FC<TileSelectProps> = ({ checked, ...rest }) => {
  return (
    <Icon
      className={classNames('vds-tile-select', {
        'vds-tile-select--checked': checked,
        'vds-tile-select--unchecked': !checked,
      })}
      name={checked ? 'checkbox-selected-circle' : 'checkbox-unselected-circle'}
      {...rest}
    />
  );
};
